import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { List, X, ArrowUpRight } from "@phosphor-icons/react";

const links = [
  { to: "/", label: "Home" },
  { to: "/offers", label: "Offers" },
  { to: "/build-package", label: "Build Package" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 18);
    h();
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [loc.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 transition-all ${
        scrolled ? "bg-[#070b14]/92 backdrop-blur-xl shadow-[0_1px_0_0_rgba(11,17,32,0.06)]" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 flex items-center justify-between h-[78px]">
        <Link to="/" data-testid="header-logo-link" className="shrink-0">
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `font-nav text-[0.82rem] uppercase tracking-[0.14em] transition-colors ${
                  isActive ? "text-[#af3fa6]" : "text-[#a8b2cc] hover:text-[#f5ecd9]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="tel:0718889055"
            className="font-nav text-[0.82rem] uppercase tracking-[0.14em] text-[#a8b2cc] hover:text-[#f5ecd9]"
            data-testid="header-phone-link"
          >
            071 888 9055
          </a>
          <Link to="/contact" className="btn-primary" data-testid="header-cta-button">
            Get a Quote
            <ArrowUpRight size={14} weight="bold" />
          </Link>
        </div>

        <button
          className="lg:hidden p-2 text-[#f5ecd9]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#070b14] border-t border-[#2c3854]" data-testid="mobile-menu">
          <div className="flex flex-col px-6 py-8 gap-4">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={`font-display text-3xl ${
                  loc.pathname === l.to ? "text-[#af3fa6]" : "text-[#f5ecd9]"
                }`}
              >
                {l.label}
              </Link>
            ))}
            <Link to="/contact" className="btn-primary self-start mt-4" data-testid="mobile-cta-button">
              Get a Quote <ArrowUpRight size={14} weight="bold" />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
